<template>
  <div id="mainPage">
    <div class="col-12 main-banner-top">
      <BannerOpacity
        id="main-page-banner"
        delay="5000"
        width="1400"
        height="800"
        class="main-page-banner-template"
      >
        <!-- <SingInPage class="main-panel-sign-in" /> -->
      </BannerOpacity>
    </div>

    <Page class="main-page-template" type="MAINPAGE" />
    <ContactForm />
  </div>
</template>

<script>
import {
  // SingInPage,
  BannerOpacity,
  Page,
  ContactForm
} from "../RedbayComponents";

export default {
  components: { BannerOpacity, Page, ContactForm }
  // beforeMount() {
  //   if (this.$store.state.user.authorizedUser) {
  //     this.$router.replace({ name: "welcomePage" });
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// src/components/template/MainPage.vue